import Swiper from 'swiper'
import { Navigation, Pagination, EffectFade, Autoplay, A11y } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
// import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

export const swiper = () => {

	homeBanner()

}

const homeBanner = () => {

	const el = document.querySelector('[data-swiper="home-banner"]')

	if (!el) return

	new Swiper(el, {
		modules: [EffectFade, Autoplay, A11y],
		speed: 800,
		effect: 'fade',
		slidesPerView: 'auto',
		spaceBetween: 20,
		timeout: 9000,
		autoplay: {
			delay: 8000,
		},
		fadeEffect: {
			crossFade: true,
		},
	})

}

export default () => { }